// Types
import type { ICsvRowGenerator } from '~/shared/import/services/csv-row-generator/types';
import type {
  TBaseImportRow,
  TImportColumnIndexes,
  TAddressImportRow,
  TUprnImportRow,
} from '~/shared/import/types';
import { EImportParamKey } from '~/shared/import/types';

// Services
import { AddressBasedCsvRowGenerator } from '~/shared/import/services/csv-row-generator/address-based';

export class SingleAddressCsvRowGenerator
  extends AddressBasedCsvRowGenerator
  implements ICsvRowGenerator<TUprnImportRow>
{
  handle(
    rawData: string[],
    headerIndexes: TImportColumnIndexes,
    selectedSourceName: string | null,
    processedRowsCount: number,
    index: number
  ): TAddressImportRow {
    const row: TBaseImportRow = this.generateBasic(
      rawData,
      headerIndexes,
      selectedSourceName,
      processedRowsCount,
      index
    );

    const postcode: string | undefined =
      rawData[headerIndexes[EImportParamKey.POSTCODE]] ||
      this.extractPostcode(rawData[headerIndexes[EImportParamKey.ADDRESS]]);

    return {
      ...row,
      full_address: rawData[headerIndexes[EImportParamKey.ADDRESS]],
      postcode,
    };
  }
}
